import { FunctionComponent } from 'react';
import styled from 'styled-components';

export const SeparatorContainer = styled.hr<{
  fullWidth?: boolean;
}>`
  width: auto;
  border: solid 1px #cccccc;
  margin: ${(props) => (props.fullWidth ? '2rem -2rem' : undefined)};
`;

interface SeparatorProps {
  fullWidth?: boolean;
}

const Separator: FunctionComponent<SeparatorProps> = (props) => {
  const { fullWidth } = props;
  return <SeparatorContainer fullWidth={fullWidth} />;
};

export default Separator;
